import { useState } from "react";

import {
  Button,
  Img,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverHeader,
  PopoverTrigger,
  Spinner,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { BsCardImage } from "react-icons/bs";
import useStore from "store";

export default function CardImage({ serial }) {
  const { t } = useTranslation("orders");
  const [imgLoading, setImgLoading] = useState(true);
  const [img, setImg] = useState("");
  const getCardImage = useStore(state => state.getCardImage);

  async function getImage(serial) {
    const res = await getCardImage(serial, true);
    setImgLoading(false);
    setImg(res);
  }

  return (
    <Popover>
      <PopoverTrigger>
        <Button
          mx="2"
          colorScheme="pink"
          size="sm"
          onClick={async e => {
            e.preventDefault;
            await getImage(serial);
          }}
        >
          <BsCardImage></BsCardImage>
        </Button>
      </PopoverTrigger>
      <PopoverContent>
        <PopoverArrow />
        <PopoverCloseButton />
        <PopoverHeader> {t("card_image.title")} </PopoverHeader>
        <PopoverBody>
          {imgLoading ? (
            <Spinner></Spinner>
          ) : (
            <Img
              src={"data:image/jpeg;base64," + img}
              alt={t("card_image.image_unavailable")}
            />
          )}
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
}
